module.exports = __webpack_public_path__ + "img/pro_thirteen_9.df48edc9.jpg";